import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './component.css';

const AdminLogin = () => {
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include", // ✅ ensures cookies/auth headers are handled properly
                body: JSON.stringify({
                    username: email.trim(),
                    password: password.trim(),
                }),
            });


            const data = await response.json();

            if (response.ok && data.success) {
                if (!data.token) {
                    alert("Login succeeded but no auth token was returned.");
                    return;
                }
                localStorage.setItem("adminToken", data.token);
                navigate("/dashboard");
            } else {
                alert(data.error || "Invalid credentials");
            }
        } catch (error) {
            console.error("Login error:", error);
            alert("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>Admin Login</h2>
                    <p>Enter your credentials to continue</p>
                </div>

                <form className="login-form" onSubmit={handleLogin}>
                    <div className="mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary w-100 login-btn"
                        disabled={loading}
                    >
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        ) : (
                            "Login"
                        )}
                    </button>
                </form>

                <div className="login-footer mt-3">
                    <a href="#">Forgot Password?</a>
                </div>
            </div>
        </div>
    );
};
export default AdminLogin;
